import { AppRouteConfig, breadcrumbs } from '..';

export enum NgoRouteName {
	ngo = 'Ngo',
	appBannerList = 'AppBannerList',
	partnerList = 'PartnerList',
	newPartner = 'NewPartner',
	planList = 'PlanList',
	editPlan = 'editPlan',
	newPlan = 'newPlan',
	productList = 'ProductList',
	staffAccountList = 'StaffAccountList',
	newStaffAccount = 'NewStaffAccount',
	editStaffAccount = 'EditStaffAccount',
	manageRole = 'ManageRole',
	viewNgoProfile = 'ViewNgoProfile',
	editNgoProfile = 'EditNgoProfile',
	centerList = 'CenterList',
	newCenter = 'NewCenter',
	editCenter = 'EditCenter',
	newAppBanner = 'NewAppBanner',
	editAppBanner = 'editAppBanner',
}

export function ngoRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'app-banners',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.appBannerList,
					component: () => import('../../views/ngoSetting/AppBannerList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('appBannerList'),
						],
						caslSubject: 'organisation.app_banners',
						caslAction: 'view',
						feature: 'ngo.appBanners',
						maskFeature: ['ngo', 'ngo.appBanners'],
					},
				},
				{
					path: 'new',
					name: NgoRouteName.newAppBanner,
					component: () => import('../../views/ngoSetting/AppBannerEdit.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('appBannerList'),
							breadcrumbs.get('newAppBanner'),
						],
						caslSubject: 'organisation.app_banners',
						caslAction: 'edit',
						feature: 'ngo.appBanners',
					},
				},
				{
					path: 'edit',
					name: NgoRouteName.editAppBanner,
					component: () => import('../../views/ngoSetting/AppBannerEdit.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('appBannerList'),
							breadcrumbs.get('editAppBanner'),
						],
						caslSubject: 'organisation.app_banners',
						caslAction: 'edit',
						feature: 'ngo.appBanners',
					},
				},
			],
		},
		{
			path: 'partner-list',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.partnerList,
					component: () => import('../../views/ngoSetting/PartnerList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('partnerList'),
						],
						caslSubject: 'organisation.partners',
						caslAction: 'view',
						feature: 'ngo.partners',
						maskFeature: ['ngo', 'ngo.partners'],
					},
				},
				{
					path: 'new',
					name: NgoRouteName.newPartner,
					component: () => import('../../views/ngoSetting/AddPartnersList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('partnerList'),
							breadcrumbs.get('addPartnerList'),
						],
						caslSubject: 'organisation.partners',
						caslAction: 'edit',
						feature: 'ngo.partners',
					},
				},
			],
		},
		{
			path: 'plans',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.planList,
					component: () => import('../../views/ngoSetting/PlanList.vue'),
					meta: {
						breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('plans')],
						caslSubject: 'organisation.plan_list',
						caslAction: 'view',
						feature: 'ngo.plans',
						maskFeature: ['ngo', 'ngo.plans'],
					},
				},
				{
					path: 'new',
					name: NgoRouteName.newPlan,
					component: () => import('../../views/ngoSetting/PlanDetails.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('plans'),
							breadcrumbs.get('newPlan'),
						],
						caslSubject: 'organisation.plan_list',
						caslAction: 'edit',
						feature: 'ngo.plans',
						dynamicFrom: 1,
					},
				},
				{
					path: ':planId',
					name: NgoRouteName.editPlan,
					component: () => import('../../views/ngoSetting/PlanDetails.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('plans'),
							breadcrumbs.get('editPlan'),
						],
						caslSubject: 'organisation.plan_list',
						caslAction: 'edit',
						feature: 'ngo.plans',
						dynamicFrom: 1,
					},
				},
			],
		},
		{
			path: 'products',
			name: NgoRouteName.productList,
			component: () => import('../../views/ngoSetting/ProductList.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('products')],
				caslSubject: 'organisation.stripe_product',
				caslAction: 'view',
				feature: 'ngo.stripe',
				maskFeature: ['ngo', 'ngo.stripe'],
			},
		},
		{
			path: 'staff',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.staffAccountList,
					component: () =>
						import('../../views/ngoSetting/StaffAccountList.vue'),
					meta: {
						breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('staff')],
						caslSubject: 'organisation.staff_account',
						caslAction: 'view',
						maskFeature: ['ngo'],
					},
				},
				{
					path: 'new',
					name: NgoRouteName.newStaffAccount,
					component: () =>
						import('../../views/ngoSetting/StaffAccountEdit.vue'),
					props: {
						isNew: true,
					},
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('staff'),
							breadcrumbs.get('newStaff'),
						],
						caslSubject: 'organisation.staff_account',
						caslAction: 'edit',
					},
				},
				{
					path: 'role',
					name: NgoRouteName.manageRole,
					component: () => import('../../views/ngoSetting/ManageRole.vue'),
					props: true,
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('staff'),
							breadcrumbs.get('userRole'),
						],
						caslSubject: 'organisation.staff_account',
						caslAction: 'edit',
					},
				},
				{
					path: ':id',
					name: NgoRouteName.editStaffAccount,
					component: () =>
						import('../../views/ngoSetting/StaffAccountEdit.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('staff'),
							breadcrumbs.get('editStaff'),
						],
						caslSubject: 'organisation.staff_account',
						caslAction: 'edit',
					},
				},
			],
		},

		{
			path: 'profile',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.viewNgoProfile,
					component: () => import('../../views/ngoSetting/NgoView.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('ngoProfile'),
						],
						caslSubject: 'organisation.organisation_profile',
						caslAction: 'view',
						maskFeature: ['ngo'],
					},
				},
				{
					path: 'edit',
					name: NgoRouteName.editNgoProfile,
					component: () => import('../../views/ngoSetting/NgoView.vue'),
					props: { editMode: true },
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('ngoProfile'),
						],
						caslSubject: 'organisation.organisation_profile',
						caslAction: 'edit',
					},
				},
			],
		},
		{
			path: 'centers',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.centerList,
					component: () => import('../../views/ngoSetting/CenterList.vue'),
					meta: {
						breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('centers')],
						caslSubject: 'organisation.unit_info',
						caslAction: 'view',
						maskFeature: ['ngo'],
					},
				},
				{
					path: 'new/edit',
					name: NgoRouteName.newCenter,
					component: () => import('../../views/ngoSetting/CenterEdit.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('centers'),
							breadcrumbs.get('newCenter'),
						],
						caslSubject: 'organisation.unit_info',
						caslAction: 'edit',
					},
				},
				{
					path: ':centerId/edit',
					name: NgoRouteName.editCenter,
					component: () => import('../../views/ngoSetting/CenterEdit.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('centers'),
							breadcrumbs.get('editCenter'),
						],
						caslSubject: 'organisation.unit_info',
						caslAction: 'edit',
					},
				},
			],
		},
		{
			path: 'donations',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: NgoRouteName.centerList,
					component: () => import('../../views/ngoSetting/Donations.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('donations'),
						],
						caslSubject: 'organisation.donation',
						caslAction: 'view',
					},
				},
			],
		},
	];
}
